var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#00A0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89009 5.89981L9.52181 6.2724C9.43464 6.36058 9.43464 6.50356 9.52181 6.59176L12.4074 9.51105L6.05639 9.51105C5.93312 9.51105 5.83317 9.61216 5.83317 9.73687L5.83317 10.2638C5.83317 10.3885 5.93312 10.4896 6.05639 10.4896L12.4074 10.4896L9.52181 13.4089C9.43464 13.4971 9.43464 13.6401 9.52181 13.7283L9.8901 14.1009C9.97726 14.189 10.1186 14.189 10.2058 14.1009L14.1011 10.16C14.1883 10.0718 14.1883 9.92884 14.1011 9.84064L10.2058 5.89979C10.1186 5.81161 9.97728 5.81161 9.89009 5.89981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowRight);
export default __webpack_public_path__ + "static/media/CircleArrowRight.3683afe7c44a4d8dc241849a27cc248f.svg";
export { ForwardRef as ReactComponent };